var COUNTRIES_WITH_DOCUMENT_ID = ['AR', 'TR', 'IN', 'UY', 'BR', 'CO', 'PY', 'MX', 'PE', 'CL', 'QA'];

function requiresDocumentId() {
  return COUNTRIES_WITH_DOCUMENT_ID.includes($('#billing_address_country').val());
}

function displayPersonalAttributes() {
  var $document_id = $('#document_id_params');

  if (requiresDocumentId()) {
    $document_id.removeClass('hidden');
  } else {
    $document_id.addClass('hidden');
  }
}

function listenForCountryChange() {
  if ($('#billing_address_country').exists) {
    displayPersonalAttributes();
  }

  $('#billing_address_country').on('change', displayPersonalAttributes);
}

var CountriesWithDocumentId = {
  listenForCountryChange: listenForCountryChange
};
export default CountriesWithDocumentId;